// @ts-nocheck
import { IconWrapper } from "@insite/mobius/Icon";
import getColor from "@insite/mobius/utilities/getColor";
import ChevronLeft from "@store/Library/Components/Toolkit/Icons/ChevronLeft";
import ChevronRight from "@store/Library/Components/Toolkit/Icons/ChevronRight";
import DoubleChevronLeft from "@store/Library/Components/Toolkit/Icons/DoubleChevronLeft";
import DoubleChevronRight from "@store/Library/Components/Toolkit/Icons/DoubleChevronRight";
import { productListPaginationWrapperStyles } from "@store/Themes/common/mixins/productList";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import { buttonResetProps } from "@store/Themes/common/props/button";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { iconScalableStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

/* Store Custom Code - Start */
import ArrowBackward from "@store/Library/Components/Toolkit/Icons/ArrowBackward";
import ArrowForward from "@store/Library/Components/Toolkit/Icons/ArrowForward";
/* Store Custom Code - End */

const itemStyles = () => {
    return css`
        display: flex;
        justify-content: center;
        min-width: ${pxToRem(32)};
        width: auto !important; /* Override breakpoint widths */
        height: ${pxToRem(32)};
        padding: ${pxToRem(0, 6)};
        margin: 0;
        border-radius: 50% /* Store Custom Code */;
        font-size: ${x => x.theme.design.typography.size.smaller};
        font-weight: ${x => x.theme.design.typography.weight.bold};
        color: ${getColor("primary") /* Store Custom Code */};
        transition: ${transitionHoverStyles("color", "background-color")};
    `;
};

const pagination: Styleguide["pagination"] = {
    defaultProps: {
        hidePerPageSelect: true,
        hideSinglePage: true,
        /* Store Custom Code - Start */
        navIconsSrc: {
            firstPage: "",
            previousPage: ArrowBackward,
            nextPage: ArrowForward,
            lastPage: "",
        },
        /* Store Custom Code - End */
        cssOverrides: {
            pagination: css`
                ${productListPaginationWrapperStyles()}
            `,
            currentButton: css`
                background-color: ${getColor("primary")};
                color: ${getColor("primary.contrast")};
            `,
            ellipsis: css`
                /* Store Removed - itemStyles */
                font-size: ${pxToRem(22)};
                line-height: ${pxToRem(20)};
                cursor: default;
                color: ${getColor("text.accent")};
                /* Store Custom Code - Start */
                display: flex !important;
                /* Store Custom Code - End */
            `,
            linkList: css`
                /* Store Custom Code - Start */
                padding: ${pxToRem(16)};
                border: 1px solid ${getColor("common.border")};
                border-left: none;
                border-right: none;
                /* Store Custom Code - End */

                ul {
                    display: flex;
                    flex-wrap: wrap;
                    align-items: center;
                    justify-content: center;
                    gap: ${pxToRem(4)};

                    ${breakpoint(360, "down")} {
                        /* Make sure the pagination does not overflow on very small displays */
                        gap: ${pxToRem(2)};
                    }
                }

                /* Store Custom Code - Start */
                li {
                    &:first-child,
                    &:last-child {
                        display: none;
                    }
                }
                /* Store Custom Code - End */
            `,
            perPageSelect: css`
                &:not(#important) /* Override breakpoint values */ {
                    width: auto;
                    margin-right: 1em;
                    margin-left: 1em;
                }
            `,
        },
        buttonProps: {
            ...buttonResetProps,
            css: css`
                ${buttonResetProps.css}
                ${itemStyles()}
                align-items: center;
                /* Store Removed Code - background-color */

                ${IconWrapper} {
                    ${iconScalableStyles("2em")}
                    justify-content: center;
                    color: ${getColor("inherit") /* Store Custom Code */};
                    top: 0;
                }

                /* Store Removed Code - disabled */

                /* Store Removed Code - disabled hover & active */
            `,
        },
        selectProps: {
            sizeVariant: "xsmall" as any,
            cssOverrides: null as any,
            labelProps: null as any,
        },
    },
};

export default pagination;
